export const propertyOf = <TObj>(name: keyof TObj) => name

export const propertyNamesOf = <TObj>() => (name: keyof TObj) => name
